import { TOKENS } from "../consts";
import getSocialButtonTypeToken from "./getSocialButtonTypeToken";
const getSocialButtonIconForeground = ({
  theme,
  type
}) => ({
  foreground: getSocialButtonTypeToken(TOKENS.iconColor, type, theme)
});
export default getSocialButtonIconForeground;